import type { AppConfig } from '../../src/utils/baseConfig';

export const config: Partial<AppConfig> = {
  tenantName: 'Arcade',
  enableStytch: false,
  showUserLoginStatus: false,
  enableSidePanel: false,
  enableStandardFeedbackButton: false,
  micMobileStyle: 'arcade',
};
